import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const fetchContact = ({modules}: StoreState) => modules.contact;
export const isContactLoading = createSelector(fetchContact, ({_isFetching}) => _isFetching);
export const isContactCreating = createSelector(fetchContact, ({_isCreating}) => _isCreating);
export const isContactModulePatching = createSelector(
    fetchContact,
    ({ _isPatching }) => _isPatching
);

export const getContactByEntityId = createSelector(
    fetchContact,
    (_, entity_id) => entity_id,
    ({ byEntityId, entities }, entity_id) => byEntityId?.[entity_id]?.map(i => entities?.[i])
);

export const getContactByIdAsObject = createSelector(
    fetchContact,
    ({entities}) => entities
)

export const getContactByEntityIdByTypeAsArray = createSelector(
    fetchContact,
    (_, entity_id) => entity_id,
    (_, __, type: 'email' | 'phone') => type,
    ({ byEntityIdByType }, entity_id, type) => byEntityIdByType?.[entity_id]?.[type]
)